import { createI18n } from 'vue-i18n'
import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

const datetimeFormats = {
    sl: {
        short: { day: 'numeric', month: 'numeric', year: 'numeric' },
        long:  { day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' },
    },
    en: {
        short: { day: 'numeric', month: 'short', year: 'numeric' },
        long:  { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' },
    },
} as const

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           'sl',
    fallbackLocale:   'en',
    messages:         { sl, en },
    datetimeFormats,
    availableLocales: ['sl', 'en'],
})

export default i18n
